/**
 *  Version gets injected by a front-end maven plugin
 *  and will override the app.version.ts already in the project
 */
export const appVersion = {
  version: '4.7.0-SNAPSHOT'
};
